import React from "react";
import TextField from "./Fields/TextField/TextField";
import Description from "./components/Description/Description";
import Error from "./components/Error/Error";
import Label from "./components/Label/Label";
import DateField from "./Fields/Date/DateField";
import SelectableField from "./Fields/SelectableField/SelectableField";
import TimeField from "./Fields/Time/TimeField";
import FileUploadField from "./Fields/FileUploadField/FileUploadField";
import { FieldType } from "../../../shared/types";
const FieldsComponentMapper = {
  [FieldType.Text]: TextField,
  [FieldType.Email]: TextField,
  [FieldType.Phone]: TextField,
  [FieldType.Link]: TextField,
  [FieldType.TextArea]: TextField,
  [FieldType.Date]: DateField,
  [FieldType.Checkbox]: SelectableField,
  [FieldType.Radio]: SelectableField,
  [FieldType.Time]: TimeField,
  [FieldType.Select]: SelectableField,
  [FieldType.File]: FileUploadField
};
const FieldView = ({
  field,
  uploadFileUrl,
  useFormProps,
  isSubmitting,
  formId,
  sectionId,
  rowId,
  columnId,
  sectionValueId,
  formSubmitSucceeded,
  text,
  elementId,
  wuiltContext
}) => {
  const error = useFormProps?.formState?.errors?.[field?.id];
  const {
    label,
    description,
    errorMessage
  } = field?.settings || {};
  const Component = FieldsComponentMapper[field.type];
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Label, {
    isError: !!error,
    label: text[label?.textId],
    htmlFor: field?.id,
    wuiltContext: wuiltContext
  }), /*#__PURE__*/React.createElement(Description, {
    isError: !!error,
    description: text[description?.textId]
  }), /*#__PURE__*/React.createElement(Component, {
    sectionId: sectionId,
    rowId: rowId,
    columnId: columnId,
    sectionValueId: sectionValueId,
    uploadFileUrl: uploadFileUrl,
    key: field?.id,
    isError: !!error,
    field: field,
    useFormProps: useFormProps,
    isSubmitting: isSubmitting,
    formId: formId,
    formSubmitSucceeded: formSubmitSucceeded,
    text: text,
    elementId: elementId,
    wuiltContext: wuiltContext
  }), /*#__PURE__*/React.createElement(Error, {
    error: error,
    errorMessage: text[errorMessage?.textId]
  }));
};
export default FieldView;
//# sourceMappingURL=FieldView.js.map